import AbstractRepository from "@/repositories/AbstractRepository";

export default class FeatureRepository extends AbstractRepository {
    protected static resource: string = "ptf-feature";

    protected static defaultFields: string[] = [
        "uuid",
        "parent.uuid",
        "code",
        "description",
    ];
}
